import { absoluteUrl } from "@/lib/site-url";

/** Единый ключ марка+модель для сравнения цен и фильтрации «пиров». */
export function normalizeCarIdentityPart(value: string | null | undefined): string {
  return (value ?? "")
    .trim()
    .replace(/\s+/g, " ")
    .normalize("NFKC")
    .toLowerCase();
}

/**
 * Экранирование для PostgREST ilike без шаблонных символов % и _.
 * https://postgrest.org/en/stable/references/api/tables_views.html#operators
 */
export function escapePostgrestIlikeExact(value: string): string {
  return value.replace(/\\/g, "\\\\").replace(/%/g, "\\%").replace(/_/g, "\\_");
}

function normalizeStoredImageUrl(u: string): string | null {
  const t = u.trim();
  if (!t) return null;
  return t.startsWith("http://") || t.startsWith("https://") ? t : absoluteUrl(t);
}

/** Извлекает «сырой» текст URL из любого поддерживаемого формата `cars.images`. */
function collectListingRawStrings(raw: unknown, out: string[]): void {
  const push = (v: unknown) => {
    if (typeof v !== "string" || !v.trim()) return;
    out.push(v.trim());
  };

  if (raw == null) return;

  if (Array.isArray(raw)) {
    for (const item of raw) collectListingRawStrings(item, out);
    return;
  }

  if (typeof raw === "string") {
    const t = raw.trim();
    if (t.startsWith("[") || t.startsWith("{")) {
      try {
        collectListingRawStrings(JSON.parse(t), out);
        return;
      } catch {
        push(t);
      }
      return;
    }
    if (t.includes("http") && (t.includes(",") || /\s/.test(t))) {
      for (const part of t.split(/[\s,]+/).filter(Boolean)) push(part.trim());
      return;
    }
    push(t);
    return;
  }

  if (typeof raw === "object") {
    for (const v of Object.values(raw as Record<string, unknown>)) collectListingRawStrings(v, out);
  }
}

/**
 * Уникальные URL фото объявления (порядок как в источнике), максимум `max`.
 */
export function collectCarListingImageUrls(raw: unknown, max = 24): string[] {
  const strings: string[] = [];
  collectListingRawStrings(raw, strings);

  const seen = new Set<string>();
  const out: string[] = [];
  for (const s of strings) {
    const n = normalizeStoredImageUrl(s);
    if (!n || seen.has(n)) continue;
    seen.add(n);
    out.push(n);
    if (out.length >= max) break;
  }
  return out;
}

/**
 * Первый рабочий URL фото из поля cars.images (массив, JSON-строка, объект с числовыми ключами).
 */
export function firstCarListingImageUrl(raw: unknown): string | null {
  const a = collectCarListingImageUrls(raw, 1);
  return a[0] ?? null;
}
